'use client';

import { useAtomValue } from 'jotai';
import Script from 'next/script';

import type { Tenant } from '@core/Entities/App/Tenants.entity';
import { hasSetCookiesAtom } from '@tracking/Atoms/HasSetCookies.atom';

import { GLOBAL_MEDIA_SCRIPT_MAP } from './GlobalMediaScriptMap';

type Props = {
  tenant?: Tenant;
};

export const GlobalMediaScript = ({ tenant }: Props) => {
  const hasSetCookies = useAtomValue(hasSetCookiesAtom);

  const clientId = tenant ? GLOBAL_MEDIA_SCRIPT_MAP[tenant] : GLOBAL_MEDIA_SCRIPT_MAP.heycar;

  if (!hasSetCookies) return null;

  return (
    <>
      <Script
        id="exelator-script"
        async
        src={`https://loadus.exelator.com/load/?p=1083&g=${clientId}`}
      ></Script>
    </>
  );
};

GlobalMediaScript.displayName = 'GlobalMediaScript';
